"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_plugin_1 = require("./shortcut-plugin");
var prosemirror_transform_1 = require("prosemirror-transform");
var prosemirror_state_1 = require("prosemirror-state");
exports.textblockTypeTextShortcut = function (regexp, name, config) {
    return new shortcut_plugin_1.TextShortcut(name, regexp, function (view, state, match, start, end) {
        var tr = state.tr;
        var $start = tr.doc.resolve(start);
        var attrs = shortcut_plugin_1.getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        var nodeType = state.schema.nodes[name];
        if (!nodeType || !$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) {
            return null;
        }
        // 标题等
        if (nodeType.isTextblock) {
            return tr.setBlockType(start, undefined, nodeType, attrs).delete(start, end);
        }
        var subNodeType = nodeType.contentMatch.defaultType;
        // 分割线等
        if (!subNodeType) {
            return tr.replaceRangeWith($start.before(), $start.after(), nodeType.create(attrs));
        }
        else if (subNodeType !== $start.node().type) {
            // 列表，引用等
            tr.setBlockType($start.before(), $start.after(), subNodeType).setSelection(prosemirror_state_1.TextSelection.create(tr.doc, state.selection.from, state.selection.to));
        }
        tr.delete(start, end);
        var range = tr.selection.$from.blockRange();
        var wrapping = range && prosemirror_transform_1.findWrapping(range, nodeType, attrs);
        if (!wrapping || !range)
            return null;
        tr.wrap(range, wrapping);
        var before = state.tr.doc.resolve(start - 1).nodeBefore;
        if (before && before.type === nodeType && prosemirror_transform_1.canJoin(tr.doc, start - 1)) {
            tr.join(start - 1);
        }
        return tr;
    }, config);
};
//# sourceMappingURL=text-block-shortcut.js.map